import Dodone from 'models/dodone'
import getModelCollection from 'braindamage/api/getModelCollection'
import { useQuery } from '@tanstack/react-query'

export default ({ query, path = "/api/dodones" } = {}) => {
  return useQuery({
    queryKey: ['dodones', path, query],
    queryFn: async () => {
      const data = await getModelCollection(path, Dodone, query)
      return data
    },
    onError: async (data) => {
      console.log("useDodoneCollectionQuery Error:", data)
    }
  })
}
